import getEnv from '@src/utils/envUtils'
import React from 'react'

const { brand } = getEnv()

interface BrandImageProps {
  imageBaseName: string
  altText: string
}

const BrandImage = ({
  imageBaseName,
  altText,
}: BrandImageProps): JSX.Element => {
  const imageSrc = require(`../assets/images/brand-images/${imageBaseName}${brand}.svg`)

  return <img src={imageSrc} alt={altText} />
}

export default BrandImage
